import {attachmentId, blendFactor, pixelBufferType, primitiveType} from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import FrameBuffer from "_src/engine/framebuffer";
import Camera from "_src/engine/camera";
import CopyShader from "_src/shaders/copy/copy";
import objFactory from "_src/engine/factories/object";
import primitiveFactory from "_src/engine/factories/primitive";
import resourceManager from "_src/render_graph/resource_manager";

export default class InterfacePass extends Pass {

  constructor(attachmentsStorage, camera) {

    super(attachmentsStorage);

    this.init(camera);

  }

  init(camera) {
    const sectionAnalysisPickScene = this._addScene(camera);
    const interfaceScene = this._addScene(camera);
    const postBlendingScene = this._addScene(camera);
    const postBlendingCopyScene = this._addScene(new Camera());
    sectionAnalysisPickScene.clearedColor = true;

    interfaceScene.clearedColor = false;
    interfaceScene.clearedDepth = false;
    interfaceScene.clearedStencil = false;

    postBlendingScene.clearedDepth = false;
    postBlendingScene.clearedStencil = false;
    postBlendingScene.isPostBlending = true;

    postBlendingCopyScene.clearedColor = false;
    const copyShader = new CopyShader({transparent : true});
    copyShader.setSourceBlendFactor(blendFactor.SRC_ALPHA);
    copyShader.setDestBlendFactor(blendFactor.ONE_MINUS_SRC_ALPHA);
    const copyScreenPlane = objFactory.createDrawable(copyShader);
    copyScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));
    postBlendingCopyScene.add(copyScreenPlane);
  }

  update() {
    const sectionAnalysisPickScene = this.getMainScene();
    const interfaceScene = this.getSecondScene();
    const postBlendingScene = this.getScenes()[2];
    const postBlendingCopyScene = this.getScenes()[3];

    const width = interfaceScene.camera.viewport[2];
    const height = interfaceScene.camera.viewport[3];

    const {sectionAnalysisPickFB, interfaceFB, postBlendingFB, postBlendingCopyFB} = this.initFramebuffer(width, height);
    sectionAnalysisPickScene.setFramebuffer(sectionAnalysisPickFB);
    interfaceScene.setFramebuffer(interfaceFB);
    postBlendingScene.setFramebuffer(postBlendingFB);
    postBlendingCopyScene.setFramebuffer(postBlendingCopyFB);

    const copyScreenPlane = postBlendingCopyScene.getChildren()[0];
    const blendingTexture = postBlendingScene.getFramebuffer().colorAttachments[0];
    copyScreenPlane.setTexture(blendingTexture, 0);
  }

  initFramebuffer(width, height) {
    const colorTexture = this.attachmentsStorage[attachmentId.BASE_COLOR_TEXTURE];
    const sectionAnalysisPickTexture = resourceManager.initBuffer(pixelBufferType.T_RGBA,
        {width, height});
    const blendingTexture = resourceManager.initBuffer(pixelBufferType.T_RGBA,
      {width, height});
    const depth = this.attachmentsStorage[attachmentId.INTERFACE_DEPTH] ? this.attachmentsStorage[attachmentId.INTERFACE_DEPTH] : this.attachmentsStorage[attachmentId.WORKSPACE_DEPTH_STENCIL];

    const sectionAnalysisPickFB = new FrameBuffer([sectionAnalysisPickTexture], null);
    const interfaceFB = new FrameBuffer([colorTexture], depth);
    const postBlendingFB = new FrameBuffer([blendingTexture], depth);
    const postBlendingCopyFB = new FrameBuffer([colorTexture], null);

    return {sectionAnalysisPickFB, interfaceFB, postBlendingFB, postBlendingCopyFB};
  }

}
